module.exports = {"url":"https://lasshopping.com","filePath":"https://lasshopping.com"}


//////////////////
// WEBPACK FOOTER
// ./src/baseurl.json
// module id = 1515
// module chunks = 0